import {
  REQUEST_DIRECT_PROFILE_SEARCH,
  RESPONSE_DIRECT_PROFILE_SEARCH,
  FAILURE_DIRECT_PROFILE_SEARCH
} from "../../actions/types";


const initialState = {
  name: "",
  isFetching: false,
  exactMatch: [],
  similarMatch: [],
  filters: {
      collabs: [],
      keywords: "",
      university: [],
      year: "",
      country: ""
  },
  error: false,
  isInitialScreen: true
};

const setFetching = (state, action) => {
  const { filters, name } = action.payload;
  return {
    ...state,
    isFetching: true,
    name: name,
    filters: filters,
    exactMatch: [],
    similarMatch: [],
    isInitialScreen: false
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    exactMatch: [],
    similarMatch: [],
    isInitialScreen: false

  };
};

const setResults = (state, action) => {
    const exactMatch = action.payload.exactMatch || [];
    const similarMatch = action.payload.similarMatch || [];

  return {
    ...state,
    isFetching: false,
    error: false,
    exactMatch,
    similarMatch,
    isInitialScreen: false
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_DIRECT_PROFILE_SEARCH:
      return setFetching(state, action);
      break;

    case RESPONSE_DIRECT_PROFILE_SEARCH:
      return setResults(state, action);

    case FAILURE_DIRECT_PROFILE_SEARCH:
      return setFailure(state, action);

    default:
      return state;
      break;
  }
};
